/**
 * Format SSN/ITIN to XXX-XX-XXXX format
 * @param {string} value - The SSN/ITIN value (can be formatted or unformatted)
 * @returns {string} - Formatted SSN/ITIN
 */
export function formatSSN(value) {
  if (!value) return "";

  // Remove all non-digits
  const digits = value.replace(/\D/g, "");

  // Limit to 9 digits
  const truncated = digits.slice(0, 9);

  // Format as XXX-XX-XXXX
  if (truncated.length >= 6) {
    return `${truncated.slice(0, 3)}-${truncated.slice(3, 5)}-${truncated.slice(
      5,
    )}`;
  } else if (truncated.length >= 4) {
    return `${truncated.slice(0, 3)}-${truncated.slice(3)}`;
  } else if (truncated.length >= 1) {
    return truncated;
  }

  return "";
}

/**
 * Clean SSN/ITIN by removing formatting (only digits)
 * @param {string} value - The formatted SSN/ITIN
 * @returns {string} - Clean SSN/ITIN with only digits
 */
export function cleanSSN(value) {
  if (!value) return "";
  return value.replace(/\D/g, "");
}

/**
 * Format SSN/ITIN input as user types
 * This function should be used in onChange handlers
 * @param {string} value - The current input value
 * @returns {string} - Formatted value
 */
export function formatSSNInput(value) {
  const cleaned = cleanSSN(value);
  return formatSSN(cleaned);
}
